<template>
  <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w">
    <p class="w100 font-18 tx-c">
      <span class="fl blue font-14 cu-p" @click="backPage">返回详情</span>
      意见反馈 - {{ title }}
    </p>

    <div class="w100 mt20 pt20 flex-box ju-c">
      <el-form class="w50" ref="form" :model="appData" label-width="80px" size="mini" v-loading="loading">
        <el-form-item label="标题内容">
          <el-input v-model="appData.title"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" v-model="appData.content"></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload ref="updata" :action="upFileUrl" :on-remove="clearFileList" :multiple="false" :limit="1" :on-success="onSuccess" :on-error="onError">
            <el-button size="small" type="success" :disabled="appData.fileId != ''">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </el-form-item>
        <el-form-item class="mt20 pt20">
          <el-button plain @click="returnData">重置</el-button>
          <el-button type="primary" @click="updata" :disabled="!appData.title || !appData.content">确认提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Feedback",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      upFileUrl: this.$http.defaults.baseURL + "uploader/file/upload",

      loading: false,
      title: "",
      appData: {
        title: "",
        content: "",
        fileId: ""
      }
    };
  },
  computed: {},
  mounted() {
    this.title = this.$route.params.title;
  },
  methods: {
    updata() {
      this.loading = true;

      this.$http
        .post(
          "viewCollect/add",
          JSON.stringify({
            processDefId: this.$route.params.id,
            title: this.appData.title,
            content: this.appData.content,
            fileId: this.appData.fileId
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.resCode == 0) {
            this.$message({
              message: data.resMsg,
              type: "success"
            });
            this.backPage();
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    returnData() {
      this.appData.title = "";
      this.appData.content = "";
      this.appData.fileId = "";
      this.$refs.updata.clearFiles();
    },
    onSuccess(response, file, fileList) {
      // console.log(response.RetData);
      if (response.RetCode) {
        const resData = eval("(" + response.RetData + ")");
        this.appData.fileId = resData.id;
      }
    },
    onError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    clearFileList() {
      this.$refs.updata.clearFiles();
      this.appData.fileId = "";
    },
    backPage() {
      this.$router.push({
        name: "server_info",
        query: {
          id: this.$route.params.id
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
